import Index from "./index.vue";
import List from "./components/List.vue";

export default [{
  path: "virtualClassRoom",
  component: Index,
  redirect: { name: "virtual-class-room-list" },
  children: [{ path: "list", name: "virtual-class-room-list", component: List }],
}];

